import axios from "axios"
import { defineStore } from "pinia"

export const useAssetStore = defineStore("image", {
  state: () => ({
    image: "https://assets.workbean.co/logo",
  }),
})
